
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 220 230"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M109.38 5.33a10.001 10.001 0 00-9.851 10.143v84.12a10.001 10.001 0 1020 0v-84.12a10.001 10.001 0 00-10.15-10.143zm70.422 34.664a10.001 10.001 0 00-6.967 17.172c16.213 16.213 26.223 38.525 26.223 63.307 0 49.564-39.964 89.527-89.527 89.527-49.564 0-89.529-39.964-89.529-89.527 0-24.782 10.01-47.094 26.223-63.307a10.001 10.001 0 10-14.14-14.139C12.276 62.837.005 90.29.005 120.474c0 60.373 49.157 109.53 109.53 109.53s109.53-49.155 109.53-109.53c0-30.186-12.27-57.64-32.08-77.449a10.001 10.001 0 00-7.176-3.03z","fill":"#fdd017"}})])
          )
        }
      }
    